import React from 'react'

import { Form, Col, Button } from '_zari/core'

const CodigoNuevoFormGroup = ({ iError, iTouched, fIsSubmitting, onClick }) => {

    const [nuevoCodigo, setNuevoCodigo] = React.useState("")

    return (
        <Form.Group>
            <Form.Label text='CODIGO NUEVO' htmlFor='select-sobrenombre' sm={2} alignRightAt='sm' />
            <Col sm={8}>
                <Form.InputText value={nuevoCodigo} disabled={fIsSubmitting} isInvalid={iTouched && iError} id='select-sobrenombre' onChange={e => setNuevoCodigo(e.target.value)} />
                {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
            </Col>
            <Button color='secondary' sm={2} onClick={() => {
                onClick(nuevoCodigo)
                setNuevoCodigo("")
            }}>
                Agregar
            </Button>
        </Form.Group>
    )
}

export default React.memo(CodigoNuevoFormGroup)
